module.exports = __webpack_public_path__ + "images/alfen_smallf57637d20fe97cf182bd1c89e3ab7ff5.png";